import { render, staticRenderFns } from "./header-menu-tooltip.vue?vue&type=template&id=feac5608&scoped=true"
import script from "./header-menu-tooltip.vue?vue&type=script&lang=js"
export * from "./header-menu-tooltip.vue?vue&type=script&lang=js"
import style0 from "./header-menu-tooltip.vue?vue&type=style&index=0&id=feac5608&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feac5608",
  null
  
)

export default component.exports